import React from "react";
import AnimatedNumbers from "react-animated-numbers";
import { ToastContainer } from "react-toastify";
import FooterFooter from "../../components/footerfooter";
//IMPORT DYNAMIC STYLED COMPONENT
import { StyledHeader } from "../../Styles";
import "./styles/newMooseBank.scss";

//SWITCH VARIABLE FOR PAGE STYLE
const theme = "GREY"; //LIGHT, GREY, RETRO
const NewMooseBank = () => {
  return (
    <>
      <div className="greyscheme">
        <StyledHeader theme={theme} />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          theme="dark"
          pauseOnHover
        />
        <div className="greyscheme">
          <div className="hero_top_container">
            <section className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="top_hero_content">
                    <div className="top_slogan">
                      <p>MOOSE SOCIETY</p>
                    </div>
                    <div className="top_hero_title">
                      <h1>ISLAND BANK</h1>
                    </div>
                    <div className="top_hero_desc">
                      <p>
                        Welcome to Moose Island Bank! Here you will be able to
                        buy, sell or trade your earned moose TRAX reward tokens!
                        <br />
                        <br />
                        Don't spend them all in one place, you never know what
                        you might need them for!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="image_box">
                <div className="row">
                  {boxItems.map((d,i) => (
                    <div key={d.id} className="col-md-3" data-aos="fade-up" data-aos-delay={`${i+5}00`}  data-aos-duration="5000" data-aos-once="true" data-aos-easing="ease-out-cubic">
                      <div className="box_wrapper">
                        <div className="image">
                          <img src={d.image} alt="img" />
                        </div>
                        <div className="bottom_text">
                          <h3>{d.title}</h3>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </div>
          <div className="hero_section_moosebank">
            <section className="container">
              <div className="row">
                <div className="col-md-6 content_col">
                  <div className="hero_content">
                    <div
                      className="title"
                      data-aos="fade-up"
                      data-aos-delay="500"
                      data-aos-duration="5000"
                      data-aos-once="true"
                      data-aos-easing="ease-in-out"
                    >
                      <h2>Claim Your Moose TRAX!</h2>
                      <span className="divider"></span>
                    </div>
                    <div className="desc">
                      Each day you hold our collections, you will earn Moose
                      TRAX. For each OG Moose you hold, you earn 10 Per Day. For
                      each Mini Moose you hold, you earn 15 Per Day.
                    </div>
                    <div className="button_text">
                      <button className="claim">claim now</button>
                      <button className="balance">balance: 23,103 TRAX</button>
                    </div>
                    <div className="counter_number">
                      <div
                        className="counter_wrapper"
                        data-aos="fade-up"
                        data-aos-delay="800"
                        data-aos-duration="5000"
                        data-aos-once="true"
                        data-aos-easing="ease-in-out"
                      >
                        <span className="count">
                          <AnimatedNumbers
                            includeComma
                            animateToNumber={10}
                            fontStyle={{ fontSize: 30 }}
                            configs={[
                              { mass: 1, tension: 220, friction: 100 },
                              { mass: 1, tension: 180, friction: 130 },
                              { mass: 1, tension: 280, friction: 90 },
                              { mass: 1, tension: 180, friction: 135 },
                              { mass: 1, tension: 260, friction: 100 },
                              { mass: 1, tension: 310, friction: 280 },
                            ]}
                          ></AnimatedNumbers>
                        </span>
                        <div className="text">Rewards</div>
                      </div>
                      <div
                        className="counter_wrapper"
                        data-aos="fade-up"
                        data-aos-delay="800"
                        data-aos-duration="5000"
                        data-aos-once="true"
                        data-aos-easing="ease-in-out"
                      >
                        <span className="count">
                          <AnimatedNumbers
                            includeComma
                            animateToNumber={2312}
                            fontStyle={{ fontSize: 30 }}
                            configs={[
                              { mass: 1, tension: 220, friction: 100 },
                              { mass: 1, tension: 180, friction: 130 },
                              { mass: 1, tension: 280, friction: 90 },
                              { mass: 1, tension: 180, friction: 135 },
                              { mass: 1, tension: 260, friction: 100 },
                              { mass: 1, tension: 210, friction: 180 },
                            ]}
                          ></AnimatedNumbers>
                        </span>
                        <div className="text">Available</div>
                      </div>
                      <div
                        className="counter_wrapper"
                        data-aos="fade-up"
                        data-aos-delay="800"
                        data-aos-duration="5000"
                        data-aos-once="true"
                        data-aos-easing="ease-in-out"
                      >
                        <span className="count">
                          <AnimatedNumbers
                            includeComma
                            animateToNumber={21342}
                            fontStyle={{ fontSize: 30 }}
                            configs={[
                              { mass: 1, tension: 220, friction: 100 },
                              { mass: 1, tension: 180, friction: 130 },
                              { mass: 1, tension: 280, friction: 90 },
                              { mass: 1, tension: 180, friction: 135 },
                              { mass: 1, tension: 260, friction: 100 },
                              { mass: 1, tension: 210, friction: 180 },
                            ]}
                          ></AnimatedNumbers>
                        </span>
                        <div className="text">Claimed</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className="hero_image"
                    data-aos="fade-up"
                    data-aos-delay="500"
                    data-aos-duration="5000"
                    data-aos-once="true"
                    data-aos-easing="ease-in-out"
                  >
                    <div className="image_bg">
                      <div className="img_wrapper">
                        <img
                          src="https://moosesocietynft.io/wp-content/uploads/elementor/thumbs/Passive_Rewardspurple-pm7jgudm11z2bx7888njx05hfx0oe7yzf7kgrxbhzc.png"
                          alt="img"
                          data-aos="fade-up"
                          data-aos-delay="1000"
                          data-aos-duration="5000"
                          data-aos-once="true"
                          data-aos-easing="ease-in-out"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <br />
          <br />
          <FooterFooter />
        </div>
      </div>
    </>
  );
};

export default NewMooseBank;

const boxItems = [
  {
    id: "1",
    image:
      "https://moosesocietynft.io/wp-content/uploads/2022/03/img-8-min.jpg",
    title: "PURCHASE TRAX",
  },
  {
    id: "2",
    image:
      "https://moosesocietynft.io/wp-content/uploads/2022/03/img-2-min.jpg",
    title: "EXCHANGE TRAX",
  },
  {
    id: "3",
    image:
      "https://moosesocietynft.io/wp-content/uploads/2022/03/img-3-min.jpg",
    title: "DONATE TRAX",
  },
  {
    id: "4",
    image:
      "https://moosesocietynft.io/wp-content/uploads/2022/03/img-7-min.jpg",
    title: "MARKETPLACE",
  },
];
